<app-entity-profile-card
  *ngIf="author && showAuthorProfile"
  [name]="author.name"
  [picture]="picture"
>
  <app-entity-follow-header
    profileTitle
    [name]="author.name"
    [active]="isAuthorSaved"
    [ignored]="isAuthorIgnored"
    [allowIgnore]="true"
    [labels]="shortcutLabels"
    [activeLabel]="authorLabel"
    [isLoading]="isAddedingOrIsRemoving"
    (toggled)="handleSaveAuthor(author)"
    (ignoreToggled)="handleIgnoreAuthor($event)"
    (labelToggled)="handleAuthorLabel($event)"
  ></app-entity-follow-header>

  <ul
    class="entity-profile__contacts"
    profileContacts
    aria-label="Contact links"
  >
    <li *ngIf="author.emailAddress && author.emailAddress != 'cbf'">
      <a [href]="'mailto:' + author.emailAddress">
        <i class="pi pi-envelope" aria-hidden="true"></i>
        <span>{{ author.emailAddress }}</span>
      </a>
    </li>
    <li *ngIf="author.contactUrl">
      <a [href]="author.contactUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-globe" aria-hidden="true"></i>
        <span>Contact</span>
      </a>
    </li>
    <li *ngIf="author.twitter && author.twitter != 'cbf'">
      <a [href]="author.twitterUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-twitter" aria-hidden="true"></i>
        <span>X</span>
      </a>
    </li>
    <li *ngIf="author.linkedIn && author.linkedIn != 'cbf'">
      <a [href]="author.linkedInUrl" target="_blank" rel="noopener noreferrer">
        <i class="pi pi-linkedin" aria-hidden="true"></i>
        <span>LinkedIn</span>
      </a>
    </li>
  </ul>

  <div
    class="entity-profile__stats"
    profileStats
    *ngIf="hasReportingAccess() && author.myCompanyStats?.numItems > 0"
  >
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <span>
      Mentioned <strong>{{ project?.name }}</strong>&nbsp;
      <strong>{{ author.myCompanyStats.numItems }}</strong> times, most recently
      on <strong>{{ author.myCompanyStats.maxDate | date }}</strong>
    </span>
  </div>
</app-entity-profile-card>
